import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import Icon from "shared/components/utils/Icon";
import { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import TextArea from "shared/components/inputs/form-fields/TextArea";
import VStack from "shared/components/layout/stack/VStack";
import styled from "styled-components";

export const LoadingWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-content: center;
    background-color: white;
`;

export const InputLabel = styled.label`
    word-break: break-all;
    color: ${COLOR_VALUES.Gray_1};
    ${TEXT_VARIANT_STYLES.Headline_5}
    margin: 0;
`;

export const StyledTextArea = styled(TextArea)`
    textarea {
        min-height: 160px;
    }
`;

export const TalentSupportMail = styled(HStack)`
    cursor: pointer;
    padding-right: 6px;
`;

export const OptionsWrapper = styled.div`
    margin-bottom: 1rem;
`;

export const StyledIcon = styled(Icon)`
    align-self: center;
`;

export const SupportWrapper = styled(VStack)`
    border-top: 1px solid ${COLOR_VALUES.Gray_5};
    margin-top: 1rem;
    padding-top: 1.5rem;
`;

export const StyledFeedbackIcon = styled(Icon)`
    flex-shrink: 0;
`;
